import { render } from "./VisibilityCheckEditor.vue?vue&type=template&id=96a62038"
import script from "./VisibilityCheckEditor.vue?vue&type=script&lang=ts"
export * from "./VisibilityCheckEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script